import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const techs = [
  { name: 'React', color: '#61DAFB' },
  { name: 'Node.js', color: '#339933' },
  { name: 'Python', color: '#3776AB' },
  { name: 'AWS', color: '#FF9900' },
  { name: 'Firebase', color: '#FFCA28' },
  { name: 'TypeScript', color: '#3178C6' },
  { name: 'PostgreSQL', color: '#4169E1' },
  { name: 'Docker', color: '#2496ED' },
  { name: 'Tailwind', color: '#06B6D4' },
  { name: 'Next.js', color: '#FFFFFF' },
  { name: 'Vercel', color: '#FFFFFF' },
  { name: 'MongoDB', color: '#47A248' },
];

const TechLogos = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-20 px-4 relative overflow-hidden">
      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <p className="eyebrow text-gray-500 text-xs mb-2">
            {t('tech.label')}
          </p>
          <h3 className="text-xl md:text-2xl font-semibold text-gray-300">
            {t('tech.title')}
          </h3>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-4 md:gap-6"
        >
          {techs.map((tech, index) => (
            <motion.div
              key={tech.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: index * 0.04 }}
              viewport={{ once: true }}
              whileHover={{ y: -3, transition: { duration: 0.2 } }}
              className="surface rounded-xl px-4 py-2.5 flex items-center gap-2 hover:border-white/15 transition-colors duration-300"
            >
              <div
                className="w-2.5 h-2.5 rounded-full shrink-0"
                style={{ backgroundColor: tech.color }}
              />
              <span className="text-sm font-medium text-gray-300">{tech.name}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechLogos;
